<cdx-slotted-modal (close)="close()" [size]="size" [mobileFullHeight]="true">
	<h3 modal-header i18n="@@pickupPointInformation-mainHeading">
		<span>How does Pick up work?</span>
	</h3>
	<div modal-content>
		<p i18n="@@pickupPointInformation-headingSummary">
			Get your order placed in your car boot or collect it yourself from the Pick up point. Simply follow the steps below.
		</p>
		<section class="instructions">
			<div class="instructions-info">
				<cdx-svg-icon name="mob-chat"></cdx-svg-icon>
				<div>
					<h5 i18n="@@pickupPointInformation-followInstructionsInSmsHeading">You'll get a text when your order is ready</h5>
					<p i18n="@@pickupPointInformation-followInstructionsInSmsHeadingContent">
						Tap the link when you're on the way
					</p>
				</div>
			</div>
			<div class="instructions-info">
				<cdx-svg-icon name="car" fill="dark"></cdx-svg-icon>
				<div>
					<h5 i18n="@@pickupPointInformation-parkingHeading">Park in one of the Pick up bays</h5>
					<p i18n="@@pickupPointInformation-parkingContent">Follow the on-site Pick up signage</p>
				</div>
			</div>
			<div class="instructions-info">
				<cdx-svg-icon name="chat" fill="dark"></cdx-svg-icon>
				<div>
					<h5 i18n="@@pickupPointInformation-letUsKnowHeading">Let us know you have arrived</h5>
					<p i18n="@@pickupPointInformation-letUsKnowContent">Via the link in the text message</p>
				</div>
			</div>
			<hr class="solid">
			<div i18n="@@pickupPointInformation-infoContent">
				<h4>Safety Instructions</h4>
				After arriving, please ensure that:
				<ul>
					<li>Your car is turned off</li>
					<li>Your handbrake is on</li>
					<li>Your boot is easily accessible</li>
					<li>{{ driveInstruction$ | async }}</li>
					<li>If self-collecting, ensure the store is safe to approach</li>
				</ul>
			</div>
			<div class="instructions-message" i18n="@@pickupPointInformation-message">
				<p>Questions? Visit our <a href="/shop/content/direct-to-boot">FAQs page</a> and learn more about pick up.</p>				
			</div>
		</section>		
	</div>
</cdx-slotted-modal>
